import { Amplify } from "aws-amplify";
import { fetchAuthSession, signIn, signUp, confirmSignUp, resendSignUpCode, signOut as amplifySignOut, signInWithRedirect } from "aws-amplify/auth";

const domain = import.meta.env.VITE_COGNITO_DOMAIN.replace(/^https?:\/\//, "");

// Amplify picks a redirect URL by matching the array against the
// current page's origin. Listing every variant the user might land on
// (apex, www, localhost during dev) avoids the "redirect is coming from
// a different origin" exception when someone hits www.ilmli.ai but the
// only redirect URL is for ilmli.ai. VITE_REDIRECT_URL is the canonical
// one (production apex); we derive the rest from the current host.
const redirectUrls = (() => {
  const out = new Set<string>([import.meta.env.VITE_REDIRECT_URL]);
  try {
    const canonical = new URL(import.meta.env.VITE_REDIRECT_URL);
    if (canonical.hostname === "ilmli.ai") {
      out.add(`https://www.ilmli.ai${canonical.pathname}`);
    } else if (canonical.hostname === "www.ilmli.ai") {
      out.add(`https://ilmli.ai${canonical.pathname}`);
    }
    out.add(`http://localhost:5173${canonical.pathname}`);
  } catch {
    // VITE_REDIRECT_URL malformed — fall back to the single entry.
  }
  return [...out];
})();

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
      loginWith: {
        oauth: {
          domain,
          scopes: ["openid", "email", "profile"],
          redirectSignIn: redirectUrls,
          redirectSignOut: redirectUrls,
          responseType: "code",
        },
        email: true,
      },
    },
  },
});

export async function getIdToken(): Promise<string | null> {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? null;
  } catch {
    return null;
  }
}

export { signIn, signUp, confirmSignUp, resendSignUpCode, amplifySignOut as signOut, signInWithRedirect };
